import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import kanbanReducer from './slices/kanban';

import schoolCourseReducer from './slices/schoolCourse';
import smallActivityReducer from './slices/smallActivity';
import SchoolResourceReducer from './slices/SchoolResource';
import calendarReducer from './slices/calendar';
import commonReducer from './slices/common';
import courseReducer from './slices/course';
import customListReducer from './slices/customList';
import schoolBasedActivityReducer from './slices/schoolBasedActivity';
import parentReducer from './slices/parent';
import mc_questionReducer from './slices/mc_question';
import schoolReducer from './slices/school';
import folderReducer from './slices/folder';
import course_itemReducer from './slices/course_item';
import merchantReducer from './slices/merchant';
import platform_resourceReducer from './slices/platform_resource';
import accountReducer from './slices/account';
import staffReducer from './slices/staff';
import curriculumActivitiesReducer from './slices/curriculumActivities';
import draftQuestionReducer from './slices/draftQuestion';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const parentPersistConfig = {
  key: 'parent',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['task_name']
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const customListPersistConfig = {
  key: 'customList',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['resourceList', 'folderList']
};

const schoolBasedActivityPersistConfig = {
  key: 'schoolBasedActivity',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['addPage', 'addResId'] // 只持久化 addPage 字段
};
const merchantPersistConfig = {
  key: 'merchant',
  storage,
  keyPrefix: 'redux-',
  blacklist: []
};
const schoolPersistConfig = {
  key: 'school',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['fullClassList']
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  schoolCourse: schoolCourseReducer,
  smallActivity: smallActivityReducer,
  SchoolResource: SchoolResourceReducer,
  common: commonReducer,
  course: courseReducer,
  customList: persistReducer(customListPersistConfig, customListReducer),
  schoolBasedActivity: persistReducer(schoolBasedActivityPersistConfig, schoolBasedActivityReducer),
  parent: persistReducer(parentPersistConfig, parentReducer),
  mc_question: mc_questionReducer,
  school: persistReducer(schoolPersistConfig, schoolReducer),
  folder: folderReducer,
  course_item: course_itemReducer,
  merchant: persistReducer(merchantPersistConfig, merchantReducer),
  platform_resource: platform_resourceReducer,
  account: accountReducer,
  staff: staffReducer,
  curriculumActivities: curriculumActivitiesReducer,
  draftQuestion: draftQuestionReducer
});

export { rootPersistConfig, rootReducer };
